module.exports = __webpack_public_path__ + "7f84b6c9166b76af67964667147140ea.pdf";